import L from "leaflet";

import { getColorByAQI } from "../utils/utils";

const useIconInit = () => {
  const FireCircleIcon = (intensity) => {
    return L.divIcon({
      className: "custom-fire-marker",
      html: `<div class="circle-fire-marker" style="width: ${intensity * 2}px; height: ${intensity * 2}px;"></div>`,
      iconSize: [intensity * 2, intensity * 2],
      iconAnchor: [intensity, intensity],
    });
  };

  const FireIcon = new L.Icon({
    iconUrl:
      "https://www.iqair.com/dl/web/img/map-clusterer/ic-fire-map-cluster.svg",
    iconSize: [40, 40],
    iconAnchor: [20, 20],
  });

  const createCustomIcon = (value) => {
    return L.divIcon({
      className: `custom-marker ${getColorByAQI(value)}`,
      html: `<div class="circle-marker">${value}</div>`,
      iconSize: [30, 30],
      iconAnchor: [15, 15],
    });
  };

  const WarningIcon = L.divIcon({
    className: "custom-warning-marker",
    html: `<div class="warning-inner"><img src="https://cdn.airvisual.net/assets/marker-images/generic.png" alt="alert" /></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });

  const markerClusterGroup = L.markerClusterGroup({
    iconCreateFunction: (cluster) => {
      const markers = cluster.getAllChildMarkers();

      const sum = markers.reduce((acc, marker) => acc + (marker.aqius || 0), 0);
      const avg = Math.round(sum / markers.length);

      let colorClass = getColorByAQI(avg);

      return L.divIcon({
        html: `<div><span>${avg}</span></div>`,
        className: `marker-cluster ${colorClass}`,
        iconSize: L.point(40, 40, true),
      });
    },
  });

  return {
    FireCircleIcon,
    FireIcon,
    createCustomIcon,
    markerClusterGroup,
    WarningIcon,
  };
};

export default useIconInit;
